<template>
  <form
    class="mt-8 max-w-[680px] bg-white p-6"
    @submit.prevent="sendData"
  >
    <div class="mb-3 flex flex-col">
      <label
        for="trial_days"
        class="mb-3 text-sm font-semibold text-gray-900"
      >Trial Days</label>
      <input
        id="trial_days"
        v-model="trial_days"
        type="number"
        class="w-full border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
      >
    </div>

    <h3 class="mb-3 text-lg font-normal">
      Expiration Date:
      <span class="underline decoration-dotted">{{
        $route.query.expires_in
      }}</span>
    </h3>

    <h3 class="mb-3 text-lg font-normal">
      Subscription:
      <span class="underline decoration-dotted">{{
        $route.query.subscription.title
      }}</span>
    </h3>

    <h3 class="mb-3 text-lg font-normal">
      Has Paid:
      <span class="capitalize underline decoration-dotted">{{
        $route.query.has_paid
      }}</span>
    </h3>

    <h3 class="mb-3 text-lg font-normal">
      Is on Trial:
      <span class="capitalize underline decoration-dotted">{{
        $route.query.is_trial
      }}</span>
    </h3>

    <button
      type="submit"
      class="mt-10 rounded bg-zuno-turquoise px-4 py-2 text-sm capitalize text-slate-50 hover:bg-zuno-turquoise/80 disabled:cursor-not-allowed disabled:bg-zuno-turquoise/70"
    >
      {{ buttonText }}
    </button>
  </form>
</template>

<script>
export default {
  name: 'SubscriptionForm',

  props: {
    trialData: {
      type: Object,
      default: () => {
        return {
          trial_period_days: '',
        }
      },
    },
    buttonText: {
      type: String,
      default: 'submit',
    },
  },

  emits: ['formDataSubmitted'],

  data() {
    return {
      trial_days: this.trialData.trial_period_days,
    }
  },

  methods: {
    sendData() {
      this.$emit('formDataSubmitted', {
        trial_period_days: this.trial_days,
        company: this.$route.query.company.id,
        subscription: this.$route.query.subscription.id,
      })
    },
  },
}
</script>
